import { useQuery } from '@tanstack/react-query'

import { applicationsApplicationsListOptions } from 'src/api/main'

const APPLICATIONS_PER_PAGE = 100

export const useSquadAppToken = (
  workspaceId: number | undefined
): string | undefined => {
  const orgId = Number(workspaceId)
  const enabled = Number.isFinite(orgId) && orgId > 0

  const { data, isLoading } = useQuery({
    ...applicationsApplicationsListOptions({
      query: { organization: orgId, per_page: APPLICATIONS_PER_PAGE }
    }),
    enabled
  })

  if (!enabled || isLoading || !data) return undefined

  const apps = data.results ?? []
  const squad = apps.find((app) => app.instance_type?.type === 'squad')
  if (squad?.token) return squad.token

  const lowestId = apps.reduce<(typeof apps)[number] | undefined>(
    (min, app) => (!min || app.id < min.id ? app : min),
    undefined
  )

  return lowestId?.token ?? undefined
}
